import type { NetworkDashboardStoreAgeFilter } from '@gozoki/api-types'
import type { JSX } from 'react'

export type StoreAgeLabelMode = 'network' | 'matureDefault'
export type StoreAgeLabelKind = NetworkDashboardStoreAgeFilter | 'mature_default'

export function getStoreAgeLabelKind(
  filter: NetworkDashboardStoreAgeFilter,
  mode: StoreAgeLabelMode,
): StoreAgeLabelKind | null {
  if (mode === 'network') {
    if (filter === 'default' || filter === 'all') return null
    return filter
  }
  if (filter === 'default') return 'mature_default'
  if (filter === 'all') return null
  return filter
}

export function getStoreAgeLabel(kind: StoreAgeLabelKind): string {
  if (kind === 'less_than_3_months') return '< 3 mois'
  if (kind === 'between_3_and_6_months') return '3-6 mois'
  if (kind === 'between_6_and_12_months') return '6-12 mois'
  if (kind === 'more_than_12_months') return '> 12 mois'
  if (kind === 'mature_default') return '> 3 mois'
  return ''
}

export function StoreAgeLabel({
  storeAgeFilter,
  mode,
  className,
}: {
  storeAgeFilter: NetworkDashboardStoreAgeFilter
  mode: StoreAgeLabelMode
  className: string
}): JSX.Element | null {
  const kind = getStoreAgeLabelKind(storeAgeFilter, mode)
  if (kind === null) return null
  return <span className={className}>{getStoreAgeLabel(kind)}</span>
}
